<template>
    <v-dialog
    v-model="dialogCreateTodo"                
    width="500"
    persistent
    >        
        <v-card>
            <v-card-title
            class="grey lighten-2 title"
            primary-title
            >               
                Nueva Visita                             
            </v-card-title>
            <v-card-text>
                
            </v-card-text>
            
            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field v-model="notaVisita" label="Nota" type="text"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field v-model="custFilter" label="Cliente" type="text" required></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-container
                        id="scroll-target"
                        style="max-height: 200px"
                        class="scroll-y"
                        fluid
                        pa-0>
                            <listaClientes/>
                        </v-container>
                    </v-flex>
                    <v-flex xs4 offset-xs1>
                        <v-text-field
                        label="Desde:"
                        v-model="start"
                        value="12:00:00"
                        type="text"
                        inputmode="numeric"
                        @change="validateStart"
                        @focus="onSelectHourInputStart"
                        @blur="onBlurHourInputStart"
                        autocomplete="off"
                        ></v-text-field>
                        <!--v-col style="flex: 0 1 auto;">
                            <h2>Desde:</h2>
                            <v-time-picker
                            v-model="start"
                            :max="end"
                            format="24hr"
                            @change="validateStart"
                            ></v-time-picker>
                        </v-col-->
                    </v-flex>
                    <v-flex xs4 offset-xs2>
                        <v-text-field
                        label="Hasta:"
                        v-model="end"
                        value="12:30:00"
                        type="text"
                        inputmode="numeric"
                        @change="validateEnd"
                        @focus="onSelectHourInputEnd"
                        @blur="onBlurHourInputEnd"
                        autocomplete="off"
                        ></v-text-field>
                        <!--v-col style="flex: 0 1 auto;">
                            <h2>Hasta:</h2>
                            <v-time-picker
                            v-model="end"
                            :min="start"
                            format="24hr"
                            @change="validateEnd"
                            ></v-time-picker>
                        </v-col-->
                    </v-flex>
                </v-layout>
            </v-container>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                flat
                @click="closeDialog()"
            >
                Cancelar
            </v-btn>
            <v-btn                
                color="success"
                flat                
                @click="closeOKDialog()"
                :loading="loading_"
                :disabled="!$store.state.customers.length || !custFilter"
            >
                Confirmar
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>
<script>
import listaClientes from '@/components/listaClientes_new.vue'
export default {
    name: 'dialogCreateTodo',
    data () {
      return {             
        timeout: null,
        alert: false,
        alertContent: '',
        validFrom: false,
        validTo: false
      }
    },
    methods:{                
        closeDialog(){           
            this.dialogCreateTodo = false;
            this.$router.push('rutas');
        },
        closeOKDialog(){  
            this.dialogCreateTodo = false;
            this.crearVisita();
            this.$router.push('rutas');
        },
        getCust(){
            let auxthis = this;
            //Para prevenir que cierren el dialog con un cliente elegido y se cambie cuando acabe una busqueda pendiendte,
            //desde que se cambie el filtro no permitiremos cerrar la page hasta que acabe la busqueda
            this.loading_ = true; 
            this.timeout = setTimeout(function () {
                auxthis.getCustomers();               
                //console.log('test');
            }, 1500);
        },
        onSelectHourInputStart(){
            if (this.start == '--:--'){
                this.start = '';
            }
        },
        onBlurHourInputStart(){
            if (this.start == ''){
                this.start = '--:--';
            }
        },
        onSelectHourInputEnd(){
            if (this.end == '--:--'){
                this.end = '';
            }
        },
        onBlurHourInputEnd(){
            if (this.end == ''){
                this.end = '--:--';
            }
        },
        validateStart(){    
            var thisaux = this;
            let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
            let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
            var a = regex.test(this.start);
            var b = regex_.test(this.start);
            if (this.start != ''){
                //Comprobamos si la hora esta correcta (con o sin punto)
                var result_reg = a || b;
                if (!result_reg){
                    this.start = '';
                    this.alertinfoContent = 'Introduzca una hora válida';
                    this.alertinfo = true;
                    setTimeout(function(){
                        thisaux.alertinfo = false;
                        thisaux.alertinfoContent = ''
                    },3000);
                    return;
                } else {
                    //Correcto
                    //Si no tiene punto...
                    if (!b){
                        this.start = this.start.substring(0,this.start.length-2) + ':' + this.start.substring(this.start.length-2);
                    }
                }
            } else {
                return;
            }
            if ((this.end != undefined) && (this.end != '--:--') && (this.end != '')){
                var fromHour = new Date("01/01/1754 " + this.start + ':00');
                var toHour = new Date("01/01/1754 " + this.end + ':00');
                
                var workTypeData = this.workTypes.find(wt =>{
                    return (wt.code == thisaux.workType) && (wt.familia == thisaux.familia);
                });
                var fromHourNAV = new Date(workTypeData.fromHour);
                var toHourNAV = new Date(workTypeData.toHour);
                if (((fromHourNAV > fromHour) || (toHourNAV < toHour))){
                    this.alertContent = 'Horas fuera del rango ' + fromHourNAV.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }) + ' - ' + toHourNAV.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
                    this.alert = true;
                    setTimeout(function(){
                        thisaux.alert = false;
                        thisaux.alertContent = ''
                    },3000);
                    if (fromHourNAV > fromHour){
                        this.start = undefined;
                    }
                    if (toHourNAV < toHour){
                        this.end = undefined;
                    }
                    return;
                }

                var result = toHour - fromHour;
                
                this.hourCount = parseFloat((result/3600000).toFixed(2));
                this.invoiceableCount = parseFloat((result/3600000).toFixed(2));
            }
            //Solo se abre si la linea es nueva
            if (this.$store.state.indexEditLine == -1) this.$store.state.dialogSignatureHourStart = true;
            setTimeout(function(){
                thisaux.validFrom = true;
            },500);
            
        },
        validateEnd(){
            var thisaux = this;
            let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
            let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
            var a = regex.test(this.end);
            var b = regex_.test(this.end);
            if (this.end != ''){
                var result_reg = a || b;
                if (!result_reg){
                    this.end = '';
                    this.alertinfoContent = 'Introduzca una hora válida';
                    this.alertinfo = true;
                    setTimeout(function(){
                        thisaux.alertinfo = false;
                        thisaux.alertinfoContent = ''
                    },3000);
                    return;
                } else {
                    //Correcto
                    //Si no tiene punto...
                    if (!b){
                        this.end = this.end.substring(0,this.end.length-2) + ':' + this.end.substring(this.end.length-2);
                    }
                }
            } else {
                return;
            }
            if ((this.start != undefined) && (this.start != '--:--') && (this.start != '')){
                var fromHour = new Date("01/01/1754 " + this.start + ':00');
                var toHour = new Date("01/01/1754 " + this.end + ':00');
                
                var workTypeData = this.workTypes.find(wt =>{
                    return (wt.code == thisaux.workType) && (wt.familia == thisaux.familia);
                });
                var fromHourNAV = new Date(workTypeData.fromHour);
                var toHourNAV = new Date(workTypeData.toHour);
                if (((fromHourNAV > fromHour) || (toHourNAV < toHour))){
                    this.alertContent = 'Horas fuera del rango ' + fromHourNAV.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }) + ' - ' + toHourNAV.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
                    this.alert = true;
                    setTimeout(function(){
                        thisaux.alert = false;
                        thisaux.alertContent = ''
                    },3000);
                    if (fromHourNAV > fromHour){
                        this.start = undefined;
                    }
                    if (toHourNAV < toHour){
                        this.end = undefined;
                    }
                    return;
                }

                var result = toHour - fromHour;
                
                this.hourCount = parseFloat((result/3600000).toFixed(2));
                this.invoiceableCount = parseFloat((result/3600000).toFixed(2));
            }
            //Solo se abre si la linea es nueva
            if (this.$store.state.indexEditLine == -1) this.$store.state.dialogSignatureHourEnd = true;
            setTimeout(function(){
                thisaux.validTo = true;
            },500);
        },
    },
    watch:{
        /*
        custFilter: function(val, oldVal){
            this.getCust();
        }*/
    },
    computed: {  
        notaVisita: {
            get(){
                return this.$store.state.dialogLastOrderData.notaVisita;
            },
            set(value){
                this.$store.commit('setNotaVisita',value);
            }
        },
        custFilter:{
            get(){
                return this.$store.state.custFilter;
            },
            set(value){
                this.$store.commit('setCustFilter',value);
            }
        },   
        loading_:{
          get(){
                return this.$store.state.activeAxiosComms.customer;
            },
          set(value){
              this.$store.commit('setCustomerLoading',value);
          } 
        },
        dialogCreateTodo:{
            get(){
                return this.$store.state.dialogCreateTodo;
            },
            set(value){
                this.$store.state.dialogCreateTodo = value;
            }
        },
        dialogCreateTodoData:{
            get(){
                return this.$store.state.dialogCreateTodoData;
            }
        },
        start: {
            get(){
                return this.$store.state.dialogCreateTodoData.start;
            },
            set(value){                
                this.$store.commit('setHourStart',value);
            }
        },
        end:{
            get(){
                return this.$store.state.dialogCreateTodoData.end;
            },
            set(value){                
                this.$store.commit('setHourEnd',value);
            }
        },
    },
    components: {
        listaClientes
    }
}
</script>

